import type { JSX } from "react";

import { VALUE_TYPE_SUBTITLE } from "@/components/IntakeMultiStep/buildAddressCardData";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/ui/common/Accordion";

interface CardProps {
  title: string;
  icon: JSX.Element;
  data: { label: string; value?: string[] | string | boolean }[];
}

const renderCardContent = (value: string | string[] | boolean) => {
  if (
    typeof value === "string" ||
    typeof value === "boolean" ||
    typeof value === "number"
  )
    return value;

  return value.join(", ");
};

export const CollapsibleCard = ({ title, icon, data }: CardProps) => {
  return (
    <Accordion type="single" collapsible>
      <AccordionItem
        value={title}
        className="rounded-lg border border-b border-neutral-100 p-4"
      >
        <AccordionTrigger>
          <div className="flex items-baseline gap-1 text-primary-600">
            {icon}
            <p className="text-primary-950">{title}</p>
          </div>
        </AccordionTrigger>
        <AccordionContent>
          {data.map(({ label, value }, index) => {
            if (value === VALUE_TYPE_SUBTITLE) {
              return (
                <div
                  key={index}
                  className="flex h-1/2 items-center gap-x-2 text-neutral-500"
                >
                  <p className="whitespace-nowrap text-sm">{label}</p>
                  <div className="flex-1 border-t border-primary-100" />
                </div>
              );
            }
            return (
              value && (
                <div
                  key={index}
                  className="flex justify-between text-neutral-500"
                >
                  <p className="text-sm font-bold">{label}</p>
                  <p>{renderCardContent(value)}</p>
                </div>
              )
            );
          })}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
